/**
 * Checks if the current environment is localhost.
 * @returns {boolean} True if hostname is 'localhost' or '127.0.0.1', false otherwise.
 */
export function isLocalhost() {
    if (typeof window === "undefined") {
        // Handle non-browser environments if necessary (e.g., SSR, testing)
        // For this case, assume not localhost unless specific logic is added
        return false;
    }
    return window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
}

/**
 * Gets the appropriate relative prefix for REST API calls based on the environment.
 * @returns {string} '/local/.rest' for localhost, '/.rest' otherwise.
 */
export function getRestUrlPrefix() {
    return isLocalhost() ? "/local/.rest" : "/.rest";
}
